import { isRight } from "fp-ts/lib/Either";
import * as t from "io-ts";
import { useContext } from "react";

import { Context } from "@reactivated";

import { WebPageURL } from "../models/nominals";
import { ReactivatedContext, getReactivatedContext } from "./environment";

const FooterSettings = t.interface({
    talk_modal_title_top: t.string,
    talk_modal_text_top: t.string,
    talk_modal_hours_top: t.string,

    talk_modal_title_middle: t.string,
    talk_modal_text_middle: t.string,
    talk_modal_hours_middle: t.string,

    talk_modal_title_bottom: t.string,
    talk_modal_text_bottom: t.string,
    talk_modal_hours_bottom: t.string,

    talk_modal_links: t.array(
        t.interface({
            id: t.string,
            title: t.string,
            url: WebPageURL,
        }),
    ),
});

type SiteSettings = Readonly<ReactivatedContext["settings"]>;

/**
 * This method gets a global, immutable Page setting
 */
export const usePageSetting = <T extends keyof SiteSettings>(
    name: T,
): SiteSettings[T] | null => {
    const ctx = useContext(Context) || getReactivatedContext();
    return ctx.settings[name];
};

/**
 * This method gets a global, immutable Page setting
 *
 * @deprecated Use `usePageSetting` instead.
 */
export const getPageSetting = <T extends keyof SiteSettings>(
    name: T,
): SiteSettings[T] | null => {
    const ctx = getReactivatedContext();
    const siteSettings: SiteSettings | null = ctx?.settings || null;
    if (!siteSettings) {
        return null;
    }
    return siteSettings[name];
};

/**
 * Load and validate basket settings from the DOM
 */
export const getFooterSettings = (): t.TypeOf<typeof FooterSettings> | null => {
    const maybeSettings = FooterSettings.decode(
        getPageSetting("footer_settings"),
    );
    return isRight(maybeSettings) ? maybeSettings.right : null;
};

export const isPageInsideIFrame = (): boolean => {
    return document.body.classList.contains("iframe-content");
};
